<template>
  <div
    class="mask"
    @touchmove.prevent
    v-if="show || loading"
  >
    <div class="loading-ctx">
      <div class="loading-4">
        <i></i>
        <i></i>
        <i></i>
        <i></i>
        <i></i>
        <i></i>
        <i></i>
        <i></i>
      </div>
      <p class="loading-text">
        {{ msg || text }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'loading',
  props: {
    loading: Boolean,
    text: {
      type: String,
      default: '加载中...'
    }
  },
  data () {
    return {
      msg: '',
      show: false
    }
  }
}
</script>

<style lang="scss" scoped>
.loading-ctx {
  position: fixed;
  width: 360px;
  height: 360px;
  top: 50%;
  left: 50%;
  background: rgba(0, 0, 0, 0.67);
  border-radius: 15px;
  transform: translate3d(-50%, -50%, 0);
  -o-transform: translate3d(-50%, -50%, 0);
  -ms-transform: translate3d(-50%, -50%, 0);
  -moz-transform: translate3d(-50%, -50%, 0);
  -webkit-transform: translate3d(-50%, -50%, 0);
  z-index: 999999;
  // 动画
  @-webkit-keyframes loadingRun {
    0%, 49%, 100% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
  }
  @keyframes loadingRun {
    0%, 49%, 100% {
      opacity: 0.5;
    }
    50% {
      opacity: 1;
    }
  }

  .loading-4 {
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    top: 80px;
    width: 150px;
    height: 150px;
    i {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      &::before {
        content: '';
        display: block;
        width: 10px;
        height: 35px;
        border-radius: 50%;
        background: #fff;
        margin: 0 auto;
        animation: loadingRun .8s infinite ease-in-out both;
      }
      &:nth-child(2) {
        transform: rotate(45deg);
        &::before {
          animation-delay: -.7s;
        }
      }
      &:nth-child(3) {
        transform: rotate(90deg);
        &::before {
          animation-delay: -.6s;
        }
      }
      &:nth-child(4) {
        transform: rotate(135deg);
        &::before {
          animation-delay: -.5s;
        }
      }
      &:nth-child(5) {
        transform: rotate(180deg);
        &::before {
          animation-delay: -.4s;
        }
      }
      &:nth-child(6) {
        transform: rotate(225deg);
        &::before {
          animation-delay: -.3s;
        }
      }
      &:nth-child(7) {
        transform: rotate(270deg);
        &::before {
          animation-delay: -.2s;
        }
      }
      &:nth-child(8) {
        transform: rotate(315deg);
        &::before {
          animation-delay: -.1s;
        }
      }
    }
  }

  .loading-text {
    position: relative;
    width: 100%;
    top: 260px;
    color: #fff;
    font-size: 42px;
    text-align: center;
  }
}
</style>
